import gql from 'graphql-tag';
import { UserSettings } from '@jupiterone/notification-types';
import { createUseQueryHook } from '@jupiterone/jupiter-web-toolkit';
import { ChannelConfigurationFragment } from './fragments';

export interface UserNotificationSettingsQueryData {
  userNotificationSettings: UserSettings;
}

export const UserNotificationSettingsQuery = gql`
  query UserNotificationSettings {
    userNotificationSettings {
      POLICIES {
        POLICY_DRAFT_APPROVED {
          ...ChannelConfigurationFragment
        }
      }
      COMPLIANCE {
        COMPLIANCE_REVIEW {
          ...ChannelConfigurationFragment
        }
      }
      INTEGRATIONS {
        INTEGRATION_FAILURE {
          ...ChannelConfigurationFragment
        }
      }
    }
  }
  ${ChannelConfigurationFragment}
`;

export const useUserNotificationSettingsQuery = createUseQueryHook<
  UserNotificationSettingsQueryData,
  {}
>(UserNotificationSettingsQuery);
